module.exports = __webpack_public_path__ + "img/Strip-Front-B9-Jb.249204d8.png";